import axios, { AxiosResponse } from "axios";
import { SupportCsvDocument } from "../../constants/SupportCsvDocument";
import {
  throwSylaApiError,
  parseProblemFromBlob,
} from "../errors/throwSylaApiError";

export async function downloadSupportCsv({
  accountId,
  financialYearValue,
  csvDocument,
}: {
  accountId: string;
  financialYearValue: string;
  csvDocument: SupportCsvDocument;
}): Promise<void> {
  let response: AxiosResponse<Blob>;
  try {
    response = await axios.get(`/accounts/${accountId}/${csvDocument.url}`, {
      params: { financialYearValue },
      responseType: "blob",
    });
  } catch (error) {
    throwSylaApiError(await parseProblemFromBlob(error));
  }

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(response.data);
  link.setAttribute(
    "download",
    response.headers["content-disposition"]?.match(/filename="(.*)"/)?.at(1) ??
      `Syla ${csvDocument.name} ${financialYearValue.replace("/", "-")}.csv`,
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return;
}
